import log from "cslog";
import { useAtom } from "jotai";
import React, { Fragment, useState } from "react";
import useMedia from "react-use/lib/useMedia";
import { MAINBAR_WIDTH } from "../constants";
import { navAtom } from "../states/qcon";
import styles from "./styles/QurealApp.module.css";

import { SparklesIcon } from "@heroicons/react/24/solid";


import QBuilt from "../qbuilt/index";

function QurealAppSingleScreen({ app, me }) {
    const isMobile = useMedia("(max-width: 700px)");
    const [collapsed, setCollapsed] = useState(true);





    const sidegap = isMobile ? 0 : MAINBAR_WIDTH;

    // const marginLeft = sidegap;
    // const marginTop = app.layout.navigation.type === "topbar" ? "50px" : 0;
    // const width = app.layout.navigation.type === "topbar" ? "auto" : "100%";

    const TOPBAR_HEIGHT = 50;
    const marginTop = 0;


    return (
        <Fragment>

            {/* <div
                className={styles.wrapper}
                style={{
                    gridTemplateColumns: "200px 1fr",
                    // gridTemplateColumns: "0 1fr",
                }}
            >
                <div
                    style={{
                        height: "100%",
                        backgroundColor: "cyan",
                    }}
                >
                    <div>
                        sidebar
                    </div>
                </div>
                <div
                    style={{
                        marginTop: marginTop,
                        overflow: "auto",
                        backgroundColor: "#F5F5F5",
                        maxHeight: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
                    }}
                >
                    {app.layout?.screen && <QBuilt screen={app.layout.screen} me={me} />}
                </div>
            </div> */}
            {app.layout?.screen && <QBuilt screen={app.layout.screen} me={me} />}

        </Fragment>
    );
}

export default QurealAppSingleScreen;
